import * as React from "react"
import { batch } from "@preact/signals-react"
import { Box, Typography } from "@mui/material"
import {IconSeeker, SelectSeeker, SwitchSeeker} from "@ui-seeker/core";

import { GROUPED_BY } from '@constants';
import { sellerDeepDiveChartActualPrice } from "../@signals";

const OPTIONS = [
    { label: 'All Data', value: GROUPED_BY.GENERAL},
    { label: 'Top Brands', value: GROUPED_BY.BRAND},
    { label: 'Top Categories', value: GROUPED_BY.CATEGORY},
    { label: 'Top Retailers', value: GROUPED_BY.RETAILER}
]


export default function SellerDeepDiveShareMblChartActions({selectedGroupedBy, handleSelectedGroupedBy, handleClickShowEvolution}) {
    const switchCurrent = 'Actual Price'

    return <Box sx={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: 1000}}>

        <Box>
        <Box component="span" sx={{ fontSize: 14, mr: 1, position: 'relative', top: 1 }}>
            List Price
        </Box>
        <SwitchSeeker
            checked={sellerDeepDiveChartActualPrice.value}
            onChange={e => {
                sellerDeepDiveChartActualPrice.value = e.target.checked
            }}
            label={switchCurrent}
        />
        </Box>
        <Box sx={{display: 'flex', alignItems: 'baseline', cursor: 'pointer', mr: 4}} onClick={() => handleClickShowEvolution()}>
            <IconSeeker icon={'chart-line'} sx={{ ml: 1, mr: 1, color: 'primary.main'}}/>
            <Typography variant="body2" sx={{display: 'block', color: "text.primary", "&:hover": {textDecoration: 'underline'}}}>
                Show All Data Evolution
            </Typography>
        </Box>

        <Box sx={{mr: 2, width: '40%'}}>
            <SelectSeeker
                options={OPTIONS}
                label="Select Grouped By"
                value={selectedGroupedBy}
                onChange={handleSelectedGroupedBy}
            />
        </Box>

    </Box>
}
